export function montaUrl(filters) {
    let url = ''
    for(let filter in filters) {
        url += `${filter}=${filters[filter]}&`
    }
    return url;
}

export default { montaUrl }